import { render, staticRenderFns } from "./infoQuery.vue?vue&type=template&id=55df93e9&scoped=true"
import script from "./infoQuery.vue?vue&type=script&lang=js"
export * from "./infoQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df93e9",
  null
  
)

export default component.exports